import validate from "validate.js";

function validateEmail(email) {
  return !validate({ from: email }, { from: { email: true } });
}

export { validateEmail };
